export default {"src":"/_next/static/media/mouse_regular.d759854c.svg","height":24,"width":24};